export interface Redirector {
  (url: string): void;
}

export default function redirectToUrl(url: string): void {
  top.location.href = url;
}
